import { graphql } from '@e-socna/data-layer';
import type { ResultOf } from '@graphql-typed-document-node/core';

export const UiSettingsContext_QuotationEmitters_Fragment = graphql(`
  fragment UiSettingsContext_QuotationEmitters_Fragment on FolderBusinessEntityConsolidation {
    quotationEmitterActors {
      _id
      thirdParty {
        _id
        color
      }
    }
  }
`);

export type UiSettingsContext_QuotationEmitters = ResultOf<
  typeof UiSettingsContext_QuotationEmitters_Fragment
>;
